// video-wrapper标签
let wrapIframe = function (options) {
  options.iframes.forEach(function (iframe) {
    var wrapper = document.createElement("div");
    wrapper.classList.add(options.iframeWrapperClass);

    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);

    iframe.src = iframe.src;
  });
};
var iframeSelectors =
  '.rte iframe[src*="youtube.com/embed"],' +
  '.rte iframe[src*="player.vimeo"],' +
  '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
  '.custom__item-inner--html iframe[src*="player.vimeo"]';

wrapIframe({
  iframes: document.querySelectorAll(iframeSelectors),
  iframeWrapperClass: "video-wrapper",
});

// scrollable-wrapper标签
let wrapTable = function (options) {
  options.tables.forEach(function (table) {
    var wrapper = document.createElement("div");
    wrapper.classList.add(options.tableWrapperClass);

    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
};

var tableSelectors = ".rte table, .custom__item-inner--html table";

wrapTable({
  tables: document.querySelectorAll(tableSelectors),
  tableWrapperClass: "scrollable-wrapper",
});
